/**
 * @file: description
 * @author:
 * @Date: 2020-03-23 09:36:07
 * @LastEditors:
 * @LastEditTime: 2020-03-24 17:34:56
 */
import { default as doArtModel } from './artModel';
import { default as doGroupModel } from './groupModel';
import { default as doMallModel } from './mallModel';
import { default as doBannerModel } from './bannerModel';
import { default as doThematicModel } from './thematicModel';

export const sagaArtModel = doArtModel.sagas;
export const sagaGroupModel = doGroupModel.sagas;
export const sagaMallModel = doMallModel.sagas;
export const sagaBannerModel = doBannerModel.sagas;
export const sagaThematicModel = doThematicModel.sagas;
